/** @jsxImportSource @emotion/react */

import React from 'react'
import { Text, CategoryType } from '@components/atoms'
import { mono } from '@components/systems/backoffice/backoffice.tokens'

interface PropsType {
	category?: CategoryType
	className?: string
	children?: string
	style?: React.CSSProperties
}

export const ErrorText = (props: PropsType) => {
	return (
		<Text
			category={props.category ?? 'p2'}
			className={props.className}
			css={{ color: mono.error }}
			style={{ ...props.style }}
		>
			{props.children}
		</Text>
	)
}
